import React, { createContext, ReactNode } from 'react';
import { isMobile as isMobileDetected } from 'react-device-detect';
import { withSize } from 'react-sizeme';

import { tablet } from '@helpers/breakpoints';

interface BreakpointProviderCtx {
  children: ReactNode;
  size: { height: number; postion: number; width: number };
}

const BreakpointProviderCtx = createContext(null);
const BreakpointProvider = ({ children, size: { width } }: BreakpointProviderCtx) => {
  const isMobile = Boolean(width < tablet) || isMobileDetected;
  return <BreakpointProviderCtx.Provider value={{ isMobile }}>{children}</BreakpointProviderCtx.Provider>;
};
export default withSize()(BreakpointProvider);

export const useBreakpoint = () => {
  if (isMobileDetected) {
    return { isMobile: true };
  } else {
    return { isMobile: false };
  }
};
